import DashHeaderOpen from 'components/markup/headers/DashHeaderOpen';
import React, { Component } from "react";
import { Helmet } from 'react-helmet';
import { Card, CardBody, CardHeader, Container } from "reactstrap";

class CodeGit extends Component {

    render() {

        return (
            <>

            <Container>

                <Helmet>
                    <title>Git</title>
                    <meta name="description" content="Git" />
                </Helmet>

                <DashHeaderOpen 
                    icon="fas fa-home" 
                    icon_link="/developers/development/backend" 
                    title={<span>Development</span>} breadcrumb_1="Code"  breadcrumb_2="Git" 
                />
                
                <Card>
                    <CardHeader>
                        <h3 className="mb-0">Pushing, pulling and everything in between</h3>
                    </CardHeader>
                    <CardBody>

                        <h4>Master Is Sacred</h4>
                        <p className="text-sm">
                            When adding your changes do not push them directly to master. This can have negative effects on production pipelines as well as make things very confusing. Pushing to master is never something you can accidentally do, period.<br/>
                            Instead create a new branch whenever you are working on updates and create a pull request for it. 
                        </p>

                        <h4>Whoops Something Went Wrong!</h4>
                        <p className="text-sm">
                            Check out this site, its a GIT damn miracle. (yes I know how bad that joke is &mdash; John )<br /> 
                            <a className="text-sm" href="https://ohshitgit.com/" target="_blank" rel="noopener noreferrer">https://ohshitgit.com/</a>
                        </p>
                       

                    </CardBody>
                </Card>
          
            </Container>
            </>
        );
    }
}

export default CodeGit